/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdataroom_Tablelabel4Inputs */

const en_coinvestments_lpdataroom_tablelabel4 = /** @type {(inputs: Coinvestments_Lpdataroom_Tablelabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data room files`)
};

/**
* | output |
* | --- |
* | "Data room files" |
*
* @param {Coinvestments_Lpdataroom_Tablelabel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdataroom_tablelabel4 = /** @type {((inputs?: Coinvestments_Lpdataroom_Tablelabel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdataroom_Tablelabel4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdataroom_tablelabel4(inputs)
});
export { coinvestments_lpdataroom_tablelabel4 as "coInvestments_lpDataRoom_tableLabel" }